import {
  Design,
  DesignModule,
  DesignModuleNode,
  DesignObject
} from '@app/types';

export type LoopObjectsAndNodesCallback = <T extends DesignObject | DesignModuleNode>(props: {
  item: T;
  appModule: T extends DesignModuleNode ? DesignModule : null
}) => void;

export type LoopObjectsAndNodesProps = {
  callback: LoopObjectsAndNodesCallback;
  serialized: Design;
};

export function loopObjectsAndNodes({
  callback,
  serialized
}: LoopObjectsAndNodesProps) {
  const { modules, objects } = serialized.components;

  modules.forEach((appModule) => {
    const { flow } = appModule.versions[1];
    flow.nodes.forEach((node) => {
      callback({ item: node, appModule });
    });
  });

  objects.forEach((object) => {
    callback({ item: object, appModule: null });
  });
}
